import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import Header from "../components/Navbar/Header";
import Loader from "../Loader/Loader";
import { post } from "../utils/helpers/http";
import useDebounce from "../hooks/useDebounce";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { formatAmount } from "../utils/helpers/helpers";

const GiftCards = () => {
  const [giftCards, setGiftCards] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [loader, setLoader] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [viewHistoryModal, setViewHistoryModal] = useState(false);
  const [redemptionHistory, setRedemptionHistory] = useState({});

  const debouncedSearch = useDebounce(searchQuery, 500);

  useEffect(() => {
    fetchGift();
  }, [pageNo, pageSize, searchKeyword]);

  const fetchGift = async () => {
    setLoader(true);
    try {
      let body = {
        pageNo: pageNo,
        pageSize: pageSize,
        searchKeyword: searchKeyword,
      };
      const response = await post("/Order/GiftVoucherList", body);

      if (response?.data?.data?.giftVoucherResponses) {
        setGiftCards(response?.data?.data?.giftVoucherResponses);

        setTotalRecords(response?.data?.data.totalRecord);
      } else {
        setGiftCards([]);
        setTotalRecords(0);
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (debouncedSearch?.trim()?.length >= 3) {
      setSearchKeyword(debouncedSearch.trim());
      setPageNo(1);
    } else if (debouncedSearch.length === 0) {
      setSearchKeyword("");
      setPageNo(1);
    }
  }, [debouncedSearch]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value?.trimStart());
  };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setPageNo(1);
  };

  const handleViewHistory = async (voucherCode) => {
    try {
      setLoader(true);
      let body = {
        pageNo: 1,
        pageSize: 100,
        searchKeyword: "",
        voucherCode: voucherCode,
      };
      const response = await post("/Order/GiftVoucherRedeemList", body);

      if (response?.data.data) {
        setRedemptionHistory(response?.data.data);
      } else {
        setRedemptionHistory({});
      }
    } finally {
      setViewHistoryModal(true);
      setLoader(false);
    }
  };

  console.log("redemptionHistory", redemptionHistory);
  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth">
                  <h1 className="page-title"> Gift Card(s)</h1>
                </div>
              </div>
              <div className="page-content">
                <div className="page-content">
                  <div className="table-filters">
                    <div className="left_filters">
                      <div className="filterBox">
                        <label className="form-filter-label">Show</label>
                        <select
                          className="form-filter form-select"
                          onChange={handlePageSizeChange}
                          value={pageSize}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                        </select>
                        <label className="ps-2">entries</label>
                      </div>
                    </div>
                    <div className="right_filters">
                      <div className="searchBox exrta-width">
                        <label>Search:</label>
                        <input
                          type="text"
                          className="form-filter"
                          placeholder="Search by Gift Code, Purchase By, Gifted To"
                          value={searchQuery}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-outerbox">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Gift Code</th>
                          <th>Purchase Date</th>
                          <th>Purchase By</th>
                          <th>Gifted To</th>
                          <th>Remaining Balance (AUS$)</th>
                          <th>Redemption History</th>
                        </tr>
                      </thead>
                      <tbody>
                        {giftCards.length ? (
                          giftCards.map((gift, index) => (
                            <tr key={index}>
                              {/* <td>{(pageNo - 1) * pageSize + index + 1}</td> */}
                              <td>{gift.id}</td>
                              <td>{gift.voucherCode || "-"}</td>
                              <td>{gift.purchasedDate || "-"}</td>
                              <td>{gift.purchasedBy || "-"}</td>
                              <td>{gift.gifttedTo || "-"}</td>
                              <td>{formatAmount(gift?.pendingAmount)}</td>
                              <td>
                                <a
                                  href="/"
                                  title="View"
                                  className="actionbtn viewAction"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleViewHistory(gift.voucherCode);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faEye} />
                                </a>
                              </td>
                            </tr>
                          ))
                        ) : loader ? (
                          ""
                        ) : (
                          <tr>
                            <td
                              colSpan="6"
                              style={{
                                textAlign: "center",
                                padding: "20px",
                                fontSize: "large",
                                fontWeight: "bold",
                              }}
                            >
                              No Data Found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="table-pagination">
                  <div className="leftpart">
                    <span className="entriesdata">
                      Showing {pageNo} to{" "}
                      {Math.min(pageNo * pageSize, totalRecords)} of{" "}
                      {totalRecords} entries{" "}
                    </span>
                  </div>
                  <div className="rightpart">
                    {giftCards.length > 0 && (
                      <div className="pagination_box">
                        <ul>
                          <li className="prev">
                            <button
                              onClick={() => setPageNo(Math.max(pageNo - 1, 1))}
                            >
                              <i className="fa-solid fa-chevron-left"></i>{" "}
                              Previous
                            </button>
                          </li>
                          {[
                            ...Array(Math.ceil(totalRecords / pageSize)).keys(),
                          ].map((page) => (
                            <li
                              key={page}
                              className={page + 1 === pageNo ? "current" : ""}
                            >
                              <button onClick={() => setPageNo(page + 1)}>
                                <span>{page + 1}</span>
                              </button>
                            </li>
                          ))}
                          <li className="next">
                            <button
                              onClick={() => {
                                const maxPage = Math.ceil(
                                  totalRecords / pageSize,
                                );
                                if (pageNo < maxPage) {
                                  setPageNo(pageNo + 1);
                                }
                              }}
                              disabled={
                                pageNo >= Math.ceil(totalRecords / pageSize)
                              }
                            >
                              Next <i className="fa-solid fa-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {loader && <Loader />}
          </div>
          <Footer />
        </div>
      </div>

      {viewHistoryModal && (
        <div
          className="modal modal-center "
          tabIndex="-1"
          role="dialog"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: "500px", width: "90%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Redemption History</h5>
                <button
                  type="button"
                  onClick={() => setViewHistoryModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <h5 className="f-12" style={{ marginBottom: "20px" }}>
                  <b>{redemptionHistory.customerName || ""}</b>
                </h5>
                <div className="chip-box">
                  <div className="amount-box">
                    <p>Original Balance (AUS$)</p>
                    <b>
                      {formatAmount(redemptionHistory?.summary?.originalAmount)}
                    </b>
                  </div>
                  <div className="amount-box">
                    <p>Consumed Balance (AUS$)</p>
                    <b>
                      {formatAmount(redemptionHistory?.summary?.consumedAmount)}
                    </b>
                  </div>

                  <div className="amount-box">
                    <p>Remaining Balance (AUS$)</p>
                    <b>
                      {formatAmount(
                        redemptionHistory?.summary?.remainingAmount,
                      )}
                    </b>
                  </div>
                </div>
                <div
                  className={`table-outerbox-modal ${redemptionHistory?.customerName ? "" : "border-0"}`}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Discount (AUS$)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {redemptionHistory?.giftVoucherRedeemResponses?.length ? (
                        redemptionHistory.giftVoucherRedeemResponses.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>
                                <Link to={`/manage-orders?id=${item.orderId}`}>
                                  {" "}
                                  {item.orderId}
                                </Link>
                              </td>
                              <td>{formatAmount(item?.giftVoucherDiscount)}</td>
                            </tr>
                          ),
                        )
                      ) : (
                        <tr>
                          <td colSpan="2" style={{ textAlign: "center" }}>
                            No Redemption History Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setViewHistoryModal(false)}
                >
                  Close
                </button>
                {/* <button
                  type="button"
                  className="btn btn-primary"
                  // onClick={viewHistoryModalhandler}
                >
                  Yes
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default GiftCards;
